import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import {
  createUser,
  changeStatus,
  resetPassword,
  getAdminUserList,
  getAdminAccountList,
  getUserDetail,
  unblockUser,
} from '../../../../actions/adminActions';
import { impersonatUser } from '../../../../actions/loginActions';
import { APP_ROOT_URL } from '../../../../actions/urlTypes';

import AccountMultiSelect from './AccountMultiSelect';
import UserInfo from './UserInfo';
import UserRoles from '../UserRoles';
import UserTeams from '../UserTeams';

import BackArrowIcon from '../../shared/BackArrowIcon';
import UserIcon from '../../shared/UserIcon';
import SubscriptionIcon from '../../shared/SubscriptionIcon';
import AccountsIcon from '../../shared/AccountsIcon';
import RoleIcon from '../../shared/RoleIcon';
import TeamIcon from '../../shared/TeamIcon';
import UserEntitlements from '../UserEntitlements';

class AddUser extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  static propTypes = {
    adminAccounts: PropTypes.instanceOf(Object),
    userDetails: PropTypes.instanceOf(Object),
    userSearchQuery: PropTypes.instanceOf(Object),
    accountsRights: PropTypes.instanceOf(Array),
    getAdminUserList: PropTypes.func,
    getAdminAccountList: PropTypes.func,
  };

  static defaultProps = {
    userDetails: {},
    userSearchQuery: {},

    accountsRights: [],
    isSuperUser: false,
  };

  state = {
    activeTab: 0,
    selectedAccount: [],
    clearAccount: false,
    firstName: '',
    lastName: '',
    emailLogin: '',
    adminAccounts: {
      data: [],
    },
    previousEmail: '',
    phoneNumber: '',
    showFormError: '',
    successMessage: '',
    userId: '',
    userAccounts: [],
    status: '',
    internalAdmin: false,
    edited: false,
    updatedTeam: [],
    updatedRole: [],
    updatedEntitlements: [],
    userDetails: '',
    createUserRequest: false,
    hasActiveSSOAccount: false,
  };

  UNSAFE_componentWillMount() {
    this.updateUserDetails(this.props.userDetails);
  }

  hasActiveSSOAccount = accounts => {
    return accounts.some(account => account.sso === true);
  };

  updateUserDetails = userDetails => {
    if (!_.isEmpty(userDetails)) {
      const selectedAccount = [];
      if (!_.isEmpty(userDetails.selectedAccount)) {
        userDetails.selectedAccount.map(account => {
          selectedAccount.push({
            accountId: account.accountId,
            accessType: account.accessType,
          });
          return false;
        });
      }

      const selectedAccountsData = this.state.adminAccounts.data.filter(
        account =>
          userDetails.selectedAccount &&
          userDetails.selectedAccount.some(
            filter => filter.accountId === account.accountId
          )
      );

      const hasActiveSSOAccount = this.hasActiveSSOAccount(
        selectedAccountsData
      );

      this.setState({
        selectedAccount,
        userAccounts: userDetails.selectedAccount,
        firstName: userDetails.firstName,
        lastName: userDetails.lastName,
        emailLogin: userDetails.emailLogin,
        phoneNumber: userDetails.phoneNumber,
        status: userDetails.status,
        userId: userDetails.userId,
        internalAdmin: userDetails.internalAdmin,
        updatedTeam: userDetails.teams,
        updatedRole: userDetails.roles,
        updatedEntitlements: userDetails.entitlements,
        userDetails,
        hasActiveSSOAccount,
      });
      this.setState({ previousEmail: userDetails.emailLogin });
    }
  };

  onTabChange = activeTab => {
    if (activeTab === 1) {
      const sq = {
        all: 'true',
      };
      this.props.getAdminAccountList(sq);
    }
    this.setState({ clearAccount: false, activeTab });
  };

  onInputChange = (e, type) => {
    this.setState({ clearAccount: false, [type]: e.target.value });
  };

  onChangeStatus = () => {
    const { status, userId } = this.state;
    const newStatus = status === 'DELETED' ? 'ACTIVE' : 'DELETED';
    this.setState({ successMessage: '', showFormError: '' }, () => {
      changeStatus(userId, newStatus).then(response => {
        if (response.data === 'SUCCESS') {
          this.setState(
            { status: newStatus, successMessage: 'User Successfully Updated' },
            () => {
              this.props.getAdminUserList(this.props.userSearchQuery);
              const sq = {
                all: 'true',
              };
              this.props.getAdminAccountList(sq);
              this.getUserDetails(this.state.userId);
            }
          );
        }
      });
    });
  };

  onResetPassword = () => {
    const { emailLogin } = this.state;
    resetPassword(emailLogin).then(response => {
      if (response.data) {
        this.setState({ successMessage: response.data });
      }
    });
  };

  onUnblockUser = userDetails => {
    unblockUser(userDetails.userId).then(response => {
      if (response.data) {
        this.setState({
          successMessage: 'The user was successfully unblocked',
        });
      }
    });
  };

  clearAll = () => {
    const selectedAccount = [];
    if (!_.isEmpty(this.props.userDetails.selectedAccount)) {
      this.props.userDetails.selectedAccount.map(account => {
        selectedAccount.push({
          accountId: account.accountId,
          accessType: account.accessType,
        });
        return false;
      });
    }
    this.setState({
      clearAccount: true,
      selectedAccount,
      firstName: this.props.userDetails.firstName || '',
      lastName: this.props.userDetails.lastName || '',
      emailLogin: this.props.userDetails.emailLogin || '',
      phoneNumber: this.props.userDetails.phoneNumber || '',
      showFormError: '',
      successMessage: '',
      activeTab: 0,
      updatedTeam: this.props.userDetails.teams || [],
      updatedRole: this.props.userDetails.roles || [],
      updatedEntitlements: this.props.userDetails.entitlements || [],
      userDetails: this.props.userDetails || '',
      createUserRequest: false,
    });
  };

  validatePhoneNumber = phoneNumber => {
    const phoneNumberPattern = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
    return phoneNumberPattern.test(phoneNumber);
  };

  validateEmail = email => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  validateEmailDomain = email => {
    let prevEmail = this.state.previousEmail;
    var domain = email.toLowerCase().substring(email.lastIndexOf('@') + 1);
    var prevDomain = prevEmail
      .toLowerCase()
      .substring(prevEmail.lastIndexOf('@') + 1);

    if (domain === prevDomain) {
      return true;
    } else if (!prevEmail) {
      return true;
    } else {
      return false;
    }
  };

  handleFormSubmit = e => {
    e.preventDefault();
    const {
      emailLogin,
      firstName,
      lastName,
      phoneNumber,
      selectedAccount,
      updatedTeam,
      updatedRole,
      updatedEntitlements,
    } = this.state;
    const email = emailLogin.trim();
    const fName = firstName.trim();
    const lName = lastName.trim();
    const pNumber = phoneNumber.trim();
    const isPhoneNumberValid = this.validatePhoneNumber(pNumber);
    const isEmailValid = this.validateEmail(email);
    const isEmailDomainValid = this.validateEmailDomain(email);
    const teams = _.cloneDeep(updatedTeam);
    const roles = _.cloneDeep(updatedRole);
    const entitlements = _.cloneDeep(updatedEntitlements);
    this.setState({ showFormError: '', successMessage: '' }, () => {
      if (!isEmailValid) {
        this.setState({ showFormError: 'Invalid email address.' });
      } else if (!isEmailDomainValid) {
        this.setState({ showFormError: 'Domain name cannot be changed' });
      } else if (pNumber && !isPhoneNumberValid) {
        this.setState({ showFormError: 'Phone number is not valid.' });
      } else if (!fName) {
        this.setState({ showFormError: 'Please enter first name.' });
      } else if (!lName) {
        this.setState({ showFormError: 'Please enter last name.' });
      } else {
        const accountUsers = [];
        const accountIds = [];
        if (!_.isEmpty(selectedAccount)) {
          selectedAccount.map(account => {
            accountUsers.push({
              accountId: account.accountId,
              accessType: account.accessType,
            });
            accountIds.push(account.accountId);
            return false;
          });
        }
        const data = {
          accountUsers,
          roles,
          teams,
          entitlements,
          firstName: fName,
          lastName: lName,
          emailLogin: email,
          phoneNumber: pNumber,
          status: this.state.userDetails.status,
          userId: this.state.userDetails.userId,
          internalAdmin: this.state.userDetails.internalAdmin,
        };
        data.roles = roles.filter(item => accountIds.includes(item.accountId));
        data.teams = teams.filter(item => accountIds.includes(item.accountId));
        data.entitlements = entitlements.filter(item =>
          accountIds.includes(item.accountId)
        );
        this.setState({ createUserRequest: true }, () => {
          createUser(data, this.state.userId).then(response => {
            if (response.data === 'SUCCESS') {
              if (this.state.userId) {
                this.setState(
                  {
                    successMessage: 'User Successfully Updated',
                    userDetails: data,
                  },
                  () => {
                    setTimeout(() => {
                      this.props.getAdminUserList(this.props.userSearchQuery);
                      const sq = {
                        all: 'true',
                      };
                      this.props.getAdminAccountList(sq);
                      this.getUserDetails(this.state.userId);
                    }, 2000);
                  }
                );
              } else {
                this.setState(
                  { successMessage: 'User Successfully Registered' },
                  () => {
                    setTimeout(() => {
                      const sq = {
                        all: 'true',
                      };
                      this.props.getAdminAccountList(sq);
                      this.clearAll();
                    }, 2000);
                  }
                );
              }
            }
            if (response.error) {
              this.setState({
                showFormError: response.error,
                createUserRequest: false,
              });
            }
          });
        });
      }
    });
  };

  getUserDetails = userId => {
    getUserDetail(userId).then(response => {
      if (response) {
        const details = {
          ...response,
          selectedAccount: response.accountUsers,
          firstName: response.firstName || '',
          lastName: response.lastName || '',
          emailLogin: response.emailLogin || '',
          phoneNumber: response.phoneNumber || '',
          status: response.status || '',
        };
        this.setState({ createUserRequest: false, activeTab: 0 }, () => {
          this.updateUserDetails(details);
        });
      }
    });
  };

  updateSelectedItems = selectedAccount => {
    selectedAccount.map((acc, i) => {
      const access = this.state.selectedAccount.find(
        account => account.accountId === acc.accountId
      )
        ? this.state.selectedAccount.find(
            account => account.accountId === acc.accountId
          ).accessType
        : 0;
      selectedAccount[i].accessType = access;
    });
    this.setState({ selectedAccount });
  };

  updatedTeam = selectedTeam => {
    this.setState({ updatedTeam: selectedTeam });
  };

  updatedRole = selectedRole => {
    this.setState({ updatedRole: selectedRole });
  };

  updatedActiveAccounts = acc => {
    this.setState({ activeAccounts: acc });
  };

  updatedEntitlements = selectedEntitlment => {
    this.setState({ updatedEntitlements: selectedEntitlment });
  };

  setSSOUser = () => {
    this.state.selectedAccount.map(item => {
      if(item.accountId===58) {
        this.setState({ hasActiveSSOAccount: true })
      }
      return 0
    })
  }

  componentDidMount() {
    const { userId, adminAccounts } = this.props;
    const sq = {
      all: 'true',
    };
    this.props.getAdminAccountList(sq);

    this.setSSOUser()
  }
  renderAccountData = () => {
    const accounts = this.props.adminAccounts.data;
    const activeAccounts = this.state.selectedAccount;
    const accountsRights = this.props.accountsRights;
    const isSuperUser = this.props.isSuperUser;
    const items = accounts.map((account, index) => {
      const activeAccount = _.filter(
        activeAccounts,
        item => item.accountId === account.accountId
      );
      const accountsRight =
        _.filter(
          accountsRights,
          item => item.accountId === account.accountId && item.accessType
        ).length || isSuperUser;
      const selected = activeAccount.length > 0;
      const items = {
        ...account,
        id: index,
        productNo: account.accountId,
        text: account.accountName,
        selected: false,
        isActive: selected,
        accountsRight,
      };
      return items;
    });
    return items;
  };

  renderTabContent = () => {
    const accounts = this.props.adminAccounts.data;
    const activeAccounts = this.state.selectedAccount;
    const accountsRights = this.props.accountsRights;
    const isSuperUser = this.props.isSuperUser;
    const {
      activeTab,
      firstName,
      lastName,
      emailLogin,
      phoneNumber,
      showFormError,
    } = this.state;

    let tabContent = (
      <UserInfo
        firstName={firstName}
        lastName={lastName}
        emailLogin={emailLogin}
        phoneNumber={phoneNumber}
        showFormError={showFormError}
        onChange={this.onInputChange}
        handleSubmit={this.handleFormSubmit}
      />
    );
    if (activeTab === 1) {
      tabContent = (
        <div className="add-user-container">
          <div className="add-user-form">
            <div className="add-user-form--wrapper">
              <div className="add-user-select-accounts">
                <AccountMultiSelect
                  accounts={accounts}
                  activeAccounts={activeAccounts}
                  updateSelectedItems={this.updateSelectedItems}
                  clearAccount={this.state.clearAccount}
                  accountsRights={accountsRights}
                  isSuperUser={isSuperUser}
                  selectedUser={this.state.selectedAccount}
                />
              </div>
            </div>
          </div>
        </div>
      );
    } else if (activeTab === 2) {
      tabContent = (
        <UserTeams
          activeTeam={this.state.updatedTeam}
          userDetails={this.state.userDetails}
          updatedTeam={this.updatedTeam}
          activeAccounts={activeAccounts}
          accounts={accounts}
        />
      );
    } else if (activeTab === 3) {
      tabContent = (
        <UserRoles
          activeRoles={this.state.updatedRole}
          userDetails={this.state.userDetails}
          updatedRole={this.updatedRole}
          updatedActiveAccounts={this.updatedActiveAccounts}
          activeAccounts={activeAccounts}
          accounts={accounts}
          isSuperUser={isSuperUser}
        />
      );
    } else if (activeTab === 4) {
      tabContent = (
        <UserEntitlements
          activeAccounts={activeAccounts}
          accounts={accounts}
          activeEntitlement={this.state.updatedEntitlements}
          updatedEntitlement={this.updatedEntitlements}
        />
      );
    }
    return tabContent;
  };

  disabledSaveButton = () => {
    const {
      firstName,
      lastName,
      emailLogin,
      phoneNumber,
      selectedAccount,
      updatedRole,
      updatedTeam,
      updatedEntitlements,
      createUserRequest,
    } = this.state;
    const { userDetails } = this.props;
    let isSaveButton = false;
    if (userDetails.userId) {
      const selectedAccountIds = _.map(
        selectedAccount,
        item => item.accountId + '' + item.accessType
      ).sort();
      const oldAccountsIds = _.map(
        userDetails.selectedAccount,
        item => item.accountId + '' + item.accessType
      ).sort();
      const selectedRoleIds = _.map(updatedRole, item => item.id).sort();
      const oldRolesIds = _.map(userDetails.roles, item => item.id).sort();
      const selectedTeamIds = _.map(updatedTeam, item => item.id).sort();
      const oldTeamsIds = _.map(userDetails.teams, item => item.id).sort();

      const selectedEntitlementsIds = _.map(
        updatedEntitlements,
        item => item.id
      ).sort();
      const oldEntitlementsIds = _.map(
        userDetails.entitlements,
        item => item.id
      ).sort();

      const isAccountChanged = _.isEqual(oldAccountsIds, selectedAccountIds);
      const isRoleChanged = _.isEqual(oldRolesIds, selectedRoleIds);
      const isTeamChanged = _.isEqual(oldTeamsIds, selectedTeamIds);
      const isEntitlementsChanged = _.isEqual(
        oldEntitlementsIds,
        selectedEntitlementsIds
      );

      isSaveButton =
        firstName !== userDetails.firstName ||
        lastName !== userDetails.lastName ||
        emailLogin !== userDetails.emailLogin ||
        phoneNumber !== userDetails.phoneNumber ||
        !isTeamChanged ||
        !isRoleChanged ||
        !isEntitlementsChanged ||
        !isAccountChanged;
    } else {
      isSaveButton = firstName || lastName || emailLogin || phoneNumber;
    }
    return !isSaveButton || createUserRequest;
  };

  render() {
    const {
      activeTab,
      showFormError,
      successMessage,
      status,
      emailLogin,
      userDetails,
    } = this.state;

    let statusButton = '';
    if (status) {
      statusButton = (
        <div tabIndex="0" className="adduser-card-button-dropdown">
          <span className="adduser-card-button">
            <span>{status}</span>
            <i className="dd-down-arrow-icon" />
          </span>
          <div className="adduser-card-button-dropdown-menu">
            <button
              onClick={this.onChangeStatus}
              className="dropdown-button"
              disabled={this.state.hasActiveSSOAccount}
            >
              {status === 'DELETED' ? 'Activate' : 'Delete User'}
            </button>
            {status !== 'DELETED' && (
              <button
                onClick={this.onResetPassword}
                className="dropdown-button"
                disabled={this.state.hasActiveSSOAccount}
              >
                Reset Password
              </button>
            )}
            {!this.state.internalAdmin &&
              status === 'ACTIVE' &&
              status !== 'INACTIVE' && (
                <button
                  onClick={() => impersonatUser(emailLogin)}
                  className="dropdown-button"
                >
                  Impersonate
                </button>
              )}
            {status !== 'DELETED' && (
              <button
                type="button"
                onClick={() => this.onUnblockUser(this.props.userDetails)}
                className="dropdown-button"
                disabled={this.state.hasActiveSSOAccount}
              >
                Unblock User
              </button>
            )}
          </div>
        </div>
      );
    }

    return (
      <div className="adduser">
        <div className="back-button">
          <Link
            to={`${APP_ROOT_URL}/admin/users`}
            className="adduser-card-button"
          >
            <BackArrowIcon />
            <span>Back</span>
          </Link>
        </div>
        <div className="adduser-card">
          <div className="adduser-card-header">
            <h1 className="adduser-card-title">
              {status ? 'Edit User' : 'Create User'}
              {status && (
                <span className="user-roles--name">
                  {`${userDetails.firstName} ${userDetails.lastName}`}{' '}
                  <span className="user-roles--email">
                    ({userDetails.emailLogin})
                  </span>
                </span>
              )}
            </h1>

            <div className="adduser-card-actions">
              <button
                type="button"
                className="btn resetButton"
                onClick={this.clearAll}
              >
                <span>Reset</span>
              </button>
              <button
                type="button"
                className="btn saveButton"
                onClick={this.handleFormSubmit}
                disabled={this.disabledSaveButton()}
              >
                <span>Save</span>
              </button>
              {statusButton}
            </div>
          </div>
          <div className="adduser-card-body">
            <div className="custom-tab">
              <div className="custom-tab--navigation">
                <ul className="custom-tab--nav">
                  <li
                    className={`custom-tab--nav-item ${
                      activeTab === 0 ? 'custom-tab--nav-active' : ' '
                    }`}
                  >
                    <button
                      onClick={() => this.onTabChange(0)}
                      className="custom-tab--nav-link"
                    >
                      <UserIcon /> Basic Info
                    </button>
                  </li>
                  <li
                    className={`custom-tab--nav-item ${
                      activeTab === 1 ? 'custom-tab--nav-active' : ' '
                    }`}
                  >
                    <button
                      onClick={() => this.onTabChange(1)}
                      className="custom-tab--nav-link"
                    >
                      <AccountsIcon /> Accounts
                    </button>
                  </li>
                  <li
                    className={`custom-tab--nav-item ${
                      activeTab === 2 ? 'custom-tab--nav-active' : ' '
                    }`}
                  >
                    <button
                      onClick={() => this.onTabChange(2)}
                      className="custom-tab--nav-link"
                    >
                      <TeamIcon /> Teams
                    </button>
                  </li>

                  <li
                    className={`custom-tab--nav-item ${
                      activeTab === 3 ? 'custom-tab--nav-active' : ' '
                    }`}
                  >
                    <button
                      onClick={() => this.onTabChange(3)}
                      className="custom-tab--nav-link"
                    >
                      <RoleIcon /> Roles
                    </button>
                  </li>
                  <li
                    className={`custom-tab--nav-item ${
                      activeTab === 4 ? 'custom-tab--nav-active' : ' '
                    }`}
                  >
                    <button
                      onClick={() => this.onTabChange(4)}
                      className="custom-tab--nav-link"
                    >
                      <SubscriptionIcon /> Subscriptions
                    </button>
                  </li>
                </ul>
                {showFormError && (
                  <div className="error-message">{showFormError}</div>
                )}
                {successMessage && (
                  <div className="success-message">{successMessage}</div>
                )}
              </div>
              <div className="custom-tab--body custom-tab-block">
                {this.renderTabContent()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ admin, login }) => {
  return {
    adminAccounts: admin.adminAccounts,
    userSearchQuery: admin.userSearchQuery,
    accountsRights: login.loginResponse.data.accounts,
    isSuperUser: login.loginResponse.data.ss0mm,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    // clearUserSearch: bindActionCreators(clearUserSearch, dispatch),
    getAdminUserList: bindActionCreators(getAdminUserList, dispatch),
    getAdminAccountList: bindActionCreators(getAdminAccountList, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddUser);
